var _circle, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42,
    r: 41.5,
    stroke: "#12877C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22,
    width: 40,
    height: 40,
    fill: "url(#pattern0_161_801)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_161_801",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_161_801",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_161_801",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADCElEQVR4nO2cTW4UMRCFzSLZu4YNhAvlAHCECAQnaDvqzchujpBrAFfgR/wdATYIsUPKsA9yUwEmEYIe3FNV7fekXo7ny3vP3aWZeJyDIAhqRGcnB+7C3ZDGcOBwzg/xHuXw1ad4TjnclcrCg4ONyPEL5XhRLp/jZ7FAMjhGXYZxeUkFQuCAESqLIQ7AAgeM0FkMcQAWOGCEzmKIA7DAASN0FkMcgAUOGKGzGOIALHDACJ3FEAdggQNGCBWj7w8pnT7yObzyKX67+oZ/u8prfIovVzk8LGu5mUQt7NTV4/42pfB+agh/DCfHdzfX3S03g2jxgYw7o14Yv0IJb8evWiuLlh5IuU3VDuNnKEN4UA20lUDKM2Nr8RSflFvYZMB1d0Q5PN0GDS+qgTYUyGZr8XV3tDPk0N+58qA/rwbaSiC1F57bMNpXIFJTJwJRNnUiEGVTJwJRNnX++E9EPNTVTJ3XAMoiO0xa44SV4jPrY6+XnjrLFDDbFk2n93f9Y5YyxU1fr+8PyxQww0PstcWPTkg8EOdcGcnKFFBvZ8Q3Vj9cJA2BjDo7OShTAKX4/Np99N92xGZ8bblNzbAz2gvEiGjuh7qxqXP5gWQjU6eWrUczc5iZOlsJxFmZOpsJxBmZOlsKxMTU2Vwg2qXFCFLCIS4tRhA4YITKYogDsMABI3QWQxyABQ4YobMY4gAscMAIncUQB2CBA0boLIY4AAscMEJnMcQBWOCAETqLIQ7AAgeM0FkMcQAWOGCEzmLsDaDHL0qoCWSFX5RQFEiPX5RQFQhJn+2byrv0Z4iXPts39X0aCGRj6RjA4gOhyutb41UHQAgEgfyPsEMWvqPVAXhjZ/uWH0g2cravlUBWVs72tRKIs3K2r5lAnJGzfS0FYuJsX3OBGJG4H+IAyiTuhzgACxwwQmcxxAFY4IAROoshDsACB4zQWQxxABY4YITOYogDsMABI3QWQxyABQ4YobMY4gAscMAIncWgFD7+BvBh7wAscLD80B37HD+N19AdOyF5cEAQBEGQK/oOo94WhiKbAFAAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalization);
export default __webpack_public_path__ + "static/media/personalization.fe301ede67957ab343e43fe2fc7977c4.svg";
export { ForwardRef as ReactComponent };